export function todoRel (rel, success, error) {
  if (rel.retcode === 0) {
    success()
  } else {
    error()
  }
}

export function appShare (title, text, imageUrl, shareUrl) {
  let shareTypes
  if (window.Prius.isIOS) {
    shareTypes = ['wechat', 'moments']
  } else {
    shareTypes = '[wechat,moments]'
  }
  window.Prius.appEventCallback({event: 'SHARE',
    data: {
      title: title,
      text: text,
      images: imageUrl,
      url: shareUrl,
      shareTypes: shareTypes
    }
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js